import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

export function PragmagoDataProcessingTerms() {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t('loanFormPage.agreements.form.fields.pragmaGoDataProcessing.title')}
      </Typography>
      <Typography sx={{ whiteSpace: 'pre-line' }}>
        {t('loanFormPage.agreements.form.fields.pragmaGoDataProcessing.content')}
      </Typography>
    </Stack>
  );
}
